import { ApiCaller } from '@/Utils/utils';

export default {
  state: {
    summary: null,
    usersAtRisk: [],
    usersAtRiskQuick: [],
    deepScanResult: null,
    deepScanLoading: false,
    cardClusters: [],
    blockedUsers: [],
    signupAttempts: [],
    autoActions: [],
    currentDetail: null,
    loading: false,
  },
  getters: {
    antifrode_summary: (state) => state.summary,
    antifrode_usersAtRisk: (state) => state.usersAtRisk,
    antifrode_usersAtRiskQuick: (state) => state.usersAtRiskQuick,
    antifrode_deepScanResult: (state) => state.deepScanResult,
    antifrode_deepScanLoading: (state) => state.deepScanLoading,
    antifrode_cardClusters: (state) => state.cardClusters,
    antifrode_blockedUsers: (state) => state.blockedUsers,
    antifrode_signupAttempts: (state) => state.signupAttempts,
    antifrode_autoActions: (state) => state.autoActions,
    antifrode_currentDetail: (state) => state.currentDetail,
    antifrode_loading: (state) => state.loading,
  },
  mutations: {
    setAntifrode_summary: (state, data) => (state.summary = data),
    setAntifrode_usersAtRisk: (state, data) => (state.usersAtRisk = data),
    setAntifrode_usersAtRiskQuick: (state, data) => (state.usersAtRiskQuick = data),
    setAntifrode_deepScanResult: (state, data) => (state.deepScanResult = data),
    setAntifrode_deepScanLoading: (state, val) => (state.deepScanLoading = val),
    setAntifrode_cardClusters: (state, data) => (state.cardClusters = data),
    setAntifrode_blockedUsers: (state, data) => (state.blockedUsers = data),
    setAntifrode_signupAttempts: (state, data) => (state.signupAttempts = data),
    setAntifrode_autoActions: (state, data) => (state.autoActions = data),
    setAntifrode_currentDetail: (state, data) => (state.currentDetail = data),
    setAntifrode_loading: (state, val) => (state.loading = val),
  },
  actions: {
    // ── READ ────────────────────────────────────────────────────────────
    fetchAntifrodeSummary: async (ctx) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/summary');
        ctx.commit('setAntifrode_summary', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeUsersAtRisk: async (ctx, payload) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/users-at-risk', payload);
        ctx.commit('setAntifrode_usersAtRisk', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeUsersAtRiskQuick: async (ctx, payload) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/users-at-risk-quick', payload);
        ctx.commit('setAntifrode_usersAtRiskQuick', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeDeepScan: async (ctx, payload) => {
      ctx.commit('setAntifrode_deepScanLoading', true);
      ctx.commit('setAntifrode_deepScanResult', null);
      try {
        const data = await ApiCaller.GET('/antifraud/users-at-risk', payload);
        ctx.commit('setAntifrode_deepScanResult', data);
      } finally {
        ctx.commit('setAntifrode_deepScanLoading', false);
      }
    },

    fetchAntifrodeCardClusters: async (ctx) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/card-clusters');
        ctx.commit('setAntifrode_cardClusters', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeBlockedUsers: async (ctx, payload) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/blocked-users', payload);
        ctx.commit('setAntifrode_blockedUsers', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeSignupAttempts: async (ctx, payload) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/signup-attempts', payload);
        ctx.commit('setAntifrode_signupAttempts', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeAutoActions: async (ctx, payload) => {
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET('/antifraud/auto-actions', payload);
        ctx.commit('setAntifrode_autoActions', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    fetchAntifrodeUserDetail: async (ctx, payload) => {
      const uid = typeof payload === 'object' ? payload.uid : payload;
      const params = typeof payload === 'object' ? payload.params : {};
      ctx.commit('setAntifrode_loading', true);
      try {
        const data = await ApiCaller.GET(`/antifraud/user/${uid}`, params);
        ctx.commit('setAntifrode_currentDetail', data);
      } finally {
        ctx.commit('setAntifrode_loading', false);
      }
    },

    // ── WRITE ───────────────────────────────────────────────────────────
    antifrode_blockUser: (_, payload) =>
      ApiCaller.POST(`/antifraud/user/${payload.uid}/block`, {
        reason: payload.reason,
      }),

    antifrode_unblockUser: (_, payload) =>
      ApiCaller.POST(`/antifraud/user/${payload.uid}/unblock`, {
        reason: payload.reason,
      }),

    antifrode_toggleWhitelistCard: (_, payload) =>
      ApiCaller.POST(`/antifraud/card/${payload.cardId}/whitelist`, {
        whitelist: payload.whitelist,
        reason: payload.reason,
      }),

    antifrode_addNote: (_, payload) =>
      ApiCaller.POST(`/antifraud/user/${payload.uid}/note`, {
        note: payload.note,
      }),
  },
};
